import { useEffect, useRef, useState } from "react";

import "./css/style.css";
export default function SliderP1({ imgArr, count }) {
    const [curentActive, setCurentActive] = useState(0);
    const [heightItem, setHeightItem] = useState(null);

    const list = useRef(null);
    useEffect(() => {
        if (list.current) {
            const elementHeight = list.current.clientHeight; // Получаем высоту элемента
            const result = elementHeight / count - 25;
            const roundedResult =
                Math.round(result * 100) / 100; // Округляем до сотых
            setHeightItem(roundedResult);
        }
    }, []);

    function SliderGo({ step }) {

        let sliderItem = list.current.querySelectorAll(
            ".sliderP1-list_item"
        );

        let transform = heightItem * -1;
        let maxIndex = imgArr.length - 1;
        let act = curentActive;
        switch (step) {
            case "goToPrev":
                act--;
                if (act < 0) {
                    act = maxIndex;
                } 
                sliderItem.forEach((el) => {
                    if (act != 0) {
                        el.style.transform = `translateY(${
                            transform *
                            (act == maxIndex
                                ? act - 1
                                : act - 1)
                        }px)`;
                    }
                });

                break;
            case "goToNext":
                act++;
                if (act > maxIndex) {
                    act= 0;
                }
                sliderItem.forEach((el) => {
                 

                    if (act != 1) {
                        el.style.transform = `translateY(${
                            transform *
                            (act == 0
                                ? act
                                : act - 1)
                        }px)`;
                    }
                });

                break;
            default:
                break;
            
        }


        setCurentActive(act);
    }

    return (
        <div className="sliderP1">
            <div ref={list} className="sliderP1-list">
                {imgArr.map((e, i) => (
                    <div
                        key={i}
                        style={{
                            height: `${heightItem}px`,
                        }}
                        className={`sliderP1-list_item ${
                            i == curentActive
                                ? "active"
                                : ""
                        }`}
                    >
                        <img loading="lazy"
                            src={
                                "/img/product/" +
                                e.name
                            }
                            alt=""
                        />
                    </div>
                ))}
                <div className="sliderP1_arrow">
                    <div
                        onClick={() =>
                            SliderGo({ step: "goToPrev" })
                        }
                        className="sliderP1_arrow-item prev"
                    ></div>
                    <div
                        onClick={() =>
                            SliderGo({ step: "goToNext" })
                        }
                        className="sliderP1_arrow-item next"
                    ></div>
                </div>
            </div>
            <div className="sliderP1-prev">
                <img 
                loading="lazy"
                    src={
                        "/img/product/" +
                        imgArr[curentActive].name
                    }
                    alt=""
                />
            </div>
        </div>
    );
}
